/* eslint-disable react-hooks/exhaustive-deps */
import { Button } from "@/components/ui/button";
import { Image } from "@/components/ui/image";
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { Link, useNavigate } from "react-router-dom";

import { useLogin } from "./useLogin.hook";

import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormMessage,
} from "@/components/ui/form";
import { getToken } from "@/lib/token";
import { useEffect } from "react";
import { PasswordInput, TextInput } from "@/components/form-input";
import { DEFAULT_ROUTE } from "@/lib/static";

export const Login = () => {
  const token = getToken();
  const navigate = useNavigate();

  useEffect(() => {
    if (token) {
      navigate(DEFAULT_ROUTE);
    }
  }, [token]);

  const { onSubmit, form } = useLogin();

  return (
    <div className="flex items-center h-full relative w-full">
      <Image
        src="/images/background.svg"
        alt=""
        className="absolute left-0  top-0 w-full h-full object-cover"
      />
      <div className="absolute left-[50%] w-[2px] h-[80%] bottom-0 bg-gray-100"></div>
      <div className="flex items-center h-full relative w-full">
        <div className="w-1/2 md:block hidden">
          <div className="flex items-center justify-center h-full">
            <div className="w-[50%] flex align-center justify-center flex-col gap-10">
              <Image src="/images/group.svg" alt="" className="w-full" />
              <Image src="/appLogo.svg" alt="" className="h-10" />
            </div>
          </div>
        </div>
        <div className="md:w-1/2 w-full">
          <div className="flex items-center justify-center h-full">
            <div className="md:w-[60%] w-[80%]">
              <Card className="md:border-0 md:shadow-none">
                <CardHeader>
                  <div className="flex justify-center mb-2 md:hidden">
                    <Image src="/appLogo.svg" alt="" className="h-10" />
                  </div>
                  <p className="text-sm font-[100] letter-spacing text-center md:text-left -mb-2">
                    Login to your account
                  </p>
                  <h1 className="text-2xl font-[500] text-center md:text-left">
                    Sign In
                  </h1>
                </CardHeader>

                <CardContent>
                  <Form {...form}>
                    <form
                      onSubmit={form.handleSubmit(onSubmit)}
                      className="space-y-8"
                    >
                      <FormField
                        control={form.control}
                        name="username"
                        render={({ field }) => (
                          <FormItem>
                            <FormControl className="relative">
                              <TextInput
                                icon="AtSign"
                                placeholder="Username"
                                iconClassName="text-primary/90"
                                field={field}
                              />
                            </FormControl>
                            <FormMessage />
                          </FormItem>
                        )}
                      />
                      <FormField
                        control={form.control}
                        name="password"
                        render={({ field }) => (
                          <FormItem>
                            <FormControl>
                              <PasswordInput
                                icon="Lock"
                                placeholder="Password"
                                iconClassName="text-primary/90"
                                field={field}
                              />
                            </FormControl>
                            <FormMessage />
                          </FormItem>
                        )}
                      />
                      <div className="text-right font-[600] text-sm mb-3">
                        <Link to="/forgot-password">Forgot Password?</Link>
                      </div>
                      <Button
                        className="w-full"
                        type="submit"
                        variant={"default"}
                        disabled={form.formState.isSubmitting}
                        loading={form.formState.isSubmitting}
                      >
                        {form.formState.isSubmitting && "Loading..."}
                        Login
                      </Button>
                    </form>
                  </Form>
                </CardContent>
              </Card>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
